import { http } from "../client";
export var searchMusicArchives = function (request) {
    return http.api
        .get("music-archives", {
        params: {
            client_id: request.clientId,
            playlist_id: request.playlistId
        }
    })
        .then(function (response) { return response.data; })
        .then(function (_a) {
        var _b = _a.data, data = _b.data, total = _b.total, stats = _b.stats;
        return { items: data, total: total, stats: stats };
    });
};
